export default {
    instructionCard: {
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        width: "70%",
    },
    strong: {
        display: "block",
        marginBottom: "10px",
        fontSize: "18px",
    },
    ul: {
        listStyleType: "none",
        padding: "0",
    },
    li: {
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
    },
    bullet: {
        marginRight: "10px",
        fontSize: "20px",
    },
    containerdropdown: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    label: {
        marginRight: '30px',
        fontWeight: 'bold',
    },
    select: {
        padding: '5px',
        borderRadius: '10px',
        border: '1px solid #ccc',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    marginBottomStyle: {
        marginBottom: '25px',
    },
    dropdownWidth: {
        width: '120px',
    },
    tenantDropdownWidth: {
        width: '200px',
    },
    gridButtonGap: {
        marginLeft: '50px',
        marginRight: '-50px',
    },
    gridRecordsMargin: {
        marginLeft: '150px',
    }
}